import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import { Flip } from 'react-toastify';
import type { ToastContainerProps } from 'react-toastify';

export const config: ToastContainerProps = {
  theme: 'colored',
  hideProgressBar: true,
  pauseOnHover: true,
  // Having draggable enables closing toast by sliding which interferes with ability to select
  // text in a toast (moving mouse to select shifts toast position an reduces opacity).
  // We are using closable toasts, so this is slide-to-close is not needed.
  draggable: false,
  transition: Flip,
  limit: 4,
  autoClose: 5000,
  position: 'top-right',
  icon: ({ type }) => {
    if (type === 'success') return <CheckCircleOutlinedIcon />;
    if (type === 'error') return <ErrorOutlineOutlinedIcon />;
    if (type === 'info') return <InfoOutlinedIcon />;
    if (type === 'warning') return <ReportProblemOutlinedIcon />;
    // default one is used for promise toasts, loading state
    return <CircularProgress size="1rem" />;
  },
};
